// extracted by mini-css-extract-plugin
export default {"image":"blog-entry_image__Gryk3","heading":"blog-entry_heading__6rFIb","body":"blog-entry_body__fwbnf","date":"blog-entry_date__b7o1T","shareLinks":"blog-entry_shareLinks__MSuRx"};